import React, { Component } from 'react';
import { Image } from 'react-bootstrap';
import '../content/css/NotAllowedPage.css';

var logo = require("../content/images/legly_logo_color.svg");

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);

        this.state = { hasError: false };
    }

    componentDidCatch(error, info) {
        this.setState({ hasError: true });
    }

    render() {

        if (this.state.hasError) {
            return (
                <div>
                    <h1>Whoops! Something went wrong</h1>
                    <span><a href="mailto:support@legly.io">Contact</a> us for support</span>
                </div>
            );
        }

        return this.props.children;
    }
}


// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.js